<script lang="ts">
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import type { DescriptionListBlockType } from './DescriptionListBlockQuery';
	const { data }: { data: DescriptionListBlockType } = $props();

	createViewController();
</script>

<ol use:ViewController>
	{#each data.items as item, index}
		<li class="container" use:EnterOnView={{ delay: index * 0.1 }}>
			<p class="text:headline-large index">{(index + 1).toString().padStart(2, '0')}</p>
			<h2 class="text:bullit-large">{item.headline}</h2>
			<p class="text:description-medium description">{item.description}</p>
		</li>
	{/each}
</ol>

<style lang="scss">
	ol {
		@include pagePadding;
		@include blockPadding;
	}

	li {
		border-top: $border;
		padding-top: 16px;
		grid-column: 1 / -1;
		@include layoutBlockGrid(false);
	}
	li:not(:last-child) {
		padding-bottom: 36px;
		@include md {
			padding-bottom: 68px;
		}
	}

	h2 {
		grid-column: 2 / 5;
		padding-bottom: 16px;
		@include md {
			padding-bottom: 0;
			grid-column: 3 / span 3;
		}
	}

	.index {
		grid-column: 1 / 2;
		@include md {
			grid-column: 1 / span 2;
		}
	}

	.description {
		grid-column: 2 / 5;
		@include md {
			grid-column: 8 / span 4;
		}
	}
</style>
